import { Form, Button, Modal, Col, Row } from "antd";
import useStore from "../store";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import ProfileChangePassword from "./module/system/UserSetting/ChangePasswordComponent";
import { useState } from "react";

const PwdResetExpAlert = observer(props => {
    const [form] = Form.useForm();
    const { AUTH } = useStore();

    const [passwordChangeModal, setPasswordChangeModal] = useState(false);

    const openPasswordChangeModal = () => {
        setPasswordChangeModal(true);
    };

    const closePasswordChangeModal = () => {
        setPasswordChangeModal(false);
    };

    const close = () => {
        props.close();
        form.resetFields();
    };

    return props.visible ? (
        <>
            <Modal
                centered
                className='statusModal'
                title={`Reset Password?`}
                open={props.visible}
                closeIcon={<FontAwesomeIcon icon={faTimes} />}
                onCancel={close}
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
                footer={[
                    <Button key='2' htmlType='button' className='cancelBtn mr-35' onClick={close}>
                        Cancel
                    </Button>,
                    <Button key='1' form='statusStaffForm' htmlType='submit' type='primary'>
                        Reset Password
                    </Button>,
                ]}
            >
                <Form form={form} id='statusStaffForm' onFinish={openPasswordChangeModal}>
                    {
                        <Row align='middle'>
                            <Col span={24} className='text-center'>
                                <h3>
                                    <span className='warning_color'>
                                        <FontAwesomeIcon className='' icon={faExclamationTriangle} />
                                    </span>
                                    Your password will expire in {AUTH?.user?.reset_pwd_exp_in_days} days. Please reset
                                    it to avoid disruption
                                </h3>
                            </Col>
                        </Row>
                    }
                </Form>
            </Modal>
            <ProfileChangePassword
                visible={passwordChangeModal}
                close={closePasswordChangeModal}
                openFrom={"resetPwdAlert"}
            />
        </>
    ) : null;
});

export default PwdResetExpAlert;
